<template>
    <v-snackbar
        :value="Boolean(message)"
        :timeout="timeout"
        color="yellow lighten-1"
        top
        center
        @input="onInput"
    >
        <div class="d-flex align-center">
            <div v-if="Boolean(message)">
                <div class="loader" />
            </div>
            <div class="subtitle-2 main--text mx-3">
                {{ message }}
            </div>
            <div>
                <icon-button
                    icon="X"
                    small
                    @click="message = null"
                />
            </div>
        </div>
    </v-snackbar>
</template>
<script>
import FeedbackNotificationModule from "@/store/modules/feedback_notification";

export default {
    name: "FeedbackNotification",
    setup() {
        const { message } = FeedbackNotificationModule();
        const timeout = 4000;

        const onInput = (value) => {
            if (!value) {
                message.value = null;
            }
        }

        return {
            message,
            onInput,
            timeout
        };
    }
};
</script>
<style scoped lang="scss">
.v-snack {
    ::v-deep .v-snack__wrapper {
        border-radius: 30px;

        .v-snack__content {
            min-height: 32px;
            padding-right: 8px;
            padding-left: 8px;
        }
    }
}

.loader {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    position: relative;
    transform:rotate(45deg);
    background: transparent;
  }
  .loader::before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border:10px solid var(--v-secondary-base);
    animation: prixClipFix 4s linear;
  }

  @keyframes prixClipFix {
      0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
      25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
      50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
      75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
      100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
  }
</style>